/* This file was automatically generated. Do not edit by hand. */

module.exports = (factory) => {
  const blankNodes = {
    'b0_c14n3': factory.namedNode('urn:rdf-validate-shacl:blank-ICrbDblpRlstcUSwjBAYZ'),
    'b0_c14n6': factory.namedNode('urn:rdf-validate-shacl:blank-pFK9KYtN26DN0NMXyH8Ar'),
    'b0_c14n0': factory.namedNode('urn:rdf-validate-shacl:blank-78BxHlZRiJnXywWTF5cqq'),
    'b0_c14n1': factory.namedNode('urn:rdf-validate-shacl:blank-x54-DFCLtSR8nEZND8Bk3'),
    'b0_c14n5': factory.namedNode('urn:rdf-validate-shacl:blank-31XwBcULxRTIx9l5dbYMx'),
    'b0_c14n2': factory.namedNode('urn:rdf-validate-shacl:blank-JIQGzDSBoYQOBoFXDRJb9'),
    'b0_c14n4': factory.namedNode('urn:rdf-validate-shacl:blank-DzoWy3baN0DSUzrH2JFJ8')
  };

  return [
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2002/07/owl#Ontology'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`This vocabulary defines terms used in SHACL, the W3C Shapes Constraint Language.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`W3C Shapes Constraint Language (SHACL) Vocabulary`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#declare'),
      blankNodes['b0_c14n3'],
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#suggestedShapesGraph'),
      factory.namedNode('http://www.w3.org/ns/shacl-shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#AbstractResult'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#AbstractResult'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The base class of validation results, typically not instantiated directly.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#AbstractResult'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#AbstractResult'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Abstract result`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#AbstractResult'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#AndConstraintComponent-and'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#AndConstraintComponent-and'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#AndConstraintComponent-and'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#and'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#AndConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#AndConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to test whether a value node conforms to all members of a provided list of shapes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#AndConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#AndConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`And constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#AndConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#AndConstraintComponent-and'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#BlankNode'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#BlankNode'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The node kind of all blank nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#BlankNode'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#BlankNode'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Blank node`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#BlankNodeOrIRI'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#BlankNodeOrIRI'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The node kind of all blank nodes or IRIs.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#BlankNodeOrIRI'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#BlankNodeOrIRI'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Blank node or IRI`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#BlankNodeOrLiteral'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#BlankNodeOrLiteral'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The node kind of all blank nodes or literals.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#BlankNodeOrLiteral'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#BlankNodeOrLiteral'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Blank node or literal`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClassConstraintComponent-class'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClassConstraintComponent-class'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClassConstraintComponent-class'),
      factory.namedNode('http://www.w3.org/ns/shacl#nodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#IRI'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClassConstraintComponent-class'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClassConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClassConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to verify that each value node is an instance of a given type.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClassConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClassConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Class constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClassConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#ClassConstraintComponent-class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClosedConstraintComponent-closed'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClosedConstraintComponent-closed'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClosedConstraintComponent-closed'),
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#boolean'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClosedConstraintComponent-closed'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#closed'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClosedConstraintComponent-ignoredProperties'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClosedConstraintComponent-ignoredProperties'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClosedConstraintComponent-ignoredProperties'),
      factory.namedNode('http://www.w3.org/ns/shacl#optional'),
      factory.literal(`true`, factory.namedNode('http://www.w3.org/2001/XMLSchema#boolean')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClosedConstraintComponent-ignoredProperties'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#ignoredProperties'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClosedConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClosedConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to indicate that focus nodes must only have values for those properties that have been explicitly enumerated via sh:property/sh:path.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClosedConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClosedConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Closed constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClosedConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#ClosedConstraintComponent-closed'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ClosedConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#ClosedConstraintComponent-ignoredProperties'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of constraint components.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameterizable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DatatypeConstraintComponent-datatype'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DatatypeConstraintComponent-datatype'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DatatypeConstraintComponent-datatype'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.literal(`1`, factory.namedNode('http://www.w3.org/2001/XMLSchema#integer')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DatatypeConstraintComponent-datatype'),
      factory.namedNode('http://www.w3.org/ns/shacl#nodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#IRI'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DatatypeConstraintComponent-datatype'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DatatypeConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DatatypeConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to restrict the datatype of all value nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DatatypeConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DatatypeConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Datatype constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DatatypeConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#DatatypeConstraintComponent-datatype'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DisjointConstraintComponent-disjoint'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DisjointConstraintComponent-disjoint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DisjointConstraintComponent-disjoint'),
      factory.namedNode('http://www.w3.org/ns/shacl#nodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#IRI'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DisjointConstraintComponent-disjoint'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#disjoint'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DisjointConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DisjointConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to verify that the set of value nodes is disjoint with the the set of nodes that have the focus node as subject and the value of a given property as predicate.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DisjointConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DisjointConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Disjoint constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#DisjointConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#DisjointConstraintComponent-disjoint'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#EqualsConstraintComponent-equals'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#EqualsConstraintComponent-equals'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#EqualsConstraintComponent-equals'),
      factory.namedNode('http://www.w3.org/ns/shacl#nodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#IRI'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#EqualsConstraintComponent-equals'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#equals'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#EqualsConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#EqualsConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to verify that the set of value nodes is equal to the set of nodes that have the focus node as subject and the value of a given property as predicate.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#EqualsConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#EqualsConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Equals constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#EqualsConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#EqualsConstraintComponent-equals'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ExpressionConstraintComponent-expression'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ExpressionConstraintComponent-expression'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ExpressionConstraintComponent-expression'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#expression'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ExpressionConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ExpressionConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to verify that a given node expression produces true for all value nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ExpressionConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ExpressionConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Expression constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ExpressionConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#ExpressionConstraintComponent-expression'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Function'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Function'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of SHACL functions.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Function'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Function'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Function`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Function'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameterizable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#HasValueConstraintComponent-hasValue'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#HasValueConstraintComponent-hasValue'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#HasValueConstraintComponent-hasValue'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#hasValue'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#HasValueConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#HasValueConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to verify that one of the value nodes is a given RDF node.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#HasValueConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#HasValueConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Has-value constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#HasValueConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#HasValueConstraintComponent-hasValue'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#IRI'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#IRI'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The node kind of all IRIs.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#IRI'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#IRI'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`IRI`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#IRIOrLiteral'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#IRIOrLiteral'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The node kind of all IRIs or literals.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#IRIOrLiteral'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#IRIOrLiteral'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`IRI or literal`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#InConstraintComponent-in'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#InConstraintComponent-in'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#InConstraintComponent-in'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.literal(`1`, factory.namedNode('http://www.w3.org/2001/XMLSchema#integer')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#InConstraintComponent-in'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#in'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#InConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#InConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to exclusively enumerate the permitted value nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#InConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#InConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`In constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#InConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#InConstraintComponent-in'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Info'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Severity'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Info'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The severity for an informational validation result.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Info'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Info'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Info`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSConstraint-js'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSConstraint-js'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSConstraint-js'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#js'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSConstraint'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSConstraint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of constraints backed by a JavaScript function.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSConstraint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSConstraint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`JavaScript-based constraint`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSConstraint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#JSExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component with the parameter sh:js linking to a sh:JSConstraint containing a sh:script.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`JavaScript constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#JSConstraint-js'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSExecutable'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Abstract base class of resources that declare an executable JavaScript.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`JavaScript executable`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSFunction'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSFunction'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of SHACL functions that execute a JavaScript function when called.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSFunction'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSFunction'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`JavaScript function`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSFunction'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#Function'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSFunction'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#JSExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSLibrary'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSLibrary'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Represents a JavaScript library, typically identified by one or more URLs of files to include.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSLibrary'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSLibrary'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`JavaScript library`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSLibrary'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSRule'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSRule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of SHACL rules expressed using JavaScript.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSRule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSRule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`JavaScript rule`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSRule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#JSExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSRule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#Rule'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSTarget'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSTarget'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of targets that are based on JavaScript functions.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSTarget'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSTarget'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`JavaScript target`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSTarget'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#JSExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSTarget'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#Target'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSTargetType'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSTargetType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The (meta) class for parameterizable targets that are based on JavaScript functions.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSTargetType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSTargetType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`JavaScript target type`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSTargetType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#JSExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSTargetType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#TargetType'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSValidator'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A SHACL validator based on JavaScript. This can be used to declare SHACL constraint components that perform JavaScript-based validation when used.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`JavaScript validator`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#JSExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#JSValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#Validator'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LanguageInConstraintComponent-languageIn'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LanguageInConstraintComponent-languageIn'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LanguageInConstraintComponent-languageIn'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.literal(`1`, factory.namedNode('http://www.w3.org/2001/XMLSchema#integer')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LanguageInConstraintComponent-languageIn'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#languageIn'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LanguageInConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LanguageInConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to enumerate language tags that all value nodes must have.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LanguageInConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LanguageInConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Language-in constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LanguageInConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#LanguageInConstraintComponent-languageIn'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanConstraintComponent-lessThan'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanConstraintComponent-lessThan'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanConstraintComponent-lessThan'),
      factory.namedNode('http://www.w3.org/ns/shacl#nodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#IRI'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanConstraintComponent-lessThan'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#lessThan'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to verify that each value node is smaller than all the nodes that have the focus node as subject and the value of a given property as predicate.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Less-than constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanConstraintComponent-lessThan'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanOrEqualsConstraintComponent-lessThanOrEquals'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanOrEqualsConstraintComponent-lessThanOrEquals'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanOrEqualsConstraintComponent-lessThanOrEquals'),
      factory.namedNode('http://www.w3.org/ns/shacl#nodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#IRI'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanOrEqualsConstraintComponent-lessThanOrEquals'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#lessThanOrEquals'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanOrEqualsConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanOrEqualsConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to verify that every value node is smaller than all the nodes that have the focus node as subject and the value of a given property as predicate.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanOrEqualsConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanOrEqualsConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`less-than-or-equals constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanOrEqualsConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#LessThanOrEqualsConstraintComponent-lessThanOrEquals'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Literal'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Literal'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The node kind of all literals.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Literal'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Literal'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Literal`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxCountConstraintComponent-maxCount'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxCountConstraintComponent-maxCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxCountConstraintComponent-maxCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#integer'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxCountConstraintComponent-maxCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.literal(`1`, factory.namedNode('http://www.w3.org/2001/XMLSchema#integer')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxCountConstraintComponent-maxCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to restrict the maximum number of value nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Max-count constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#MaxCountConstraintComponent-maxCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxExclusiveConstraintComponent-maxExclusive'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxExclusiveConstraintComponent-maxExclusive'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxExclusiveConstraintComponent-maxExclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.literal(`1`, factory.namedNode('http://www.w3.org/2001/XMLSchema#integer')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxExclusiveConstraintComponent-maxExclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#nodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#Literal'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxExclusiveConstraintComponent-maxExclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxExclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxExclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxExclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to restrict the range of value nodes with a maximum exclusive value.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxExclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxExclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Max-exclusive constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxExclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#MaxExclusiveConstraintComponent-maxExclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxInclusiveConstraintComponent-maxInclusive'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxInclusiveConstraintComponent-maxInclusive'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxInclusiveConstraintComponent-maxInclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.literal(`1`, factory.namedNode('http://www.w3.org/2001/XMLSchema#integer')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxInclusiveConstraintComponent-maxInclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#nodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#Literal'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxInclusiveConstraintComponent-maxInclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxInclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxInclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxInclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to restrict the range of value nodes with a maximum inclusive value.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxInclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxInclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Max-inclusive constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxInclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#MaxInclusiveConstraintComponent-maxInclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxLengthConstraintComponent-maxLength'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxLengthConstraintComponent-maxLength'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxLengthConstraintComponent-maxLength'),
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#integer'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxLengthConstraintComponent-maxLength'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.literal(`1`, factory.namedNode('http://www.w3.org/2001/XMLSchema#integer')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxLengthConstraintComponent-maxLength'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxLength'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxLengthConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxLengthConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to restrict the maximum string length of value nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxLengthConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxLengthConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Max-length constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MaxLengthConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#MaxLengthConstraintComponent-maxLength'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinCountConstraintComponent-minCount'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinCountConstraintComponent-minCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinCountConstraintComponent-minCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#integer'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinCountConstraintComponent-minCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.literal(`1`, factory.namedNode('http://www.w3.org/2001/XMLSchema#integer')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinCountConstraintComponent-minCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#minCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to restrict the minimum number of value nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Min-count constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#MinCountConstraintComponent-minCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinExclusiveConstraintComponent-minExclusive'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinExclusiveConstraintComponent-minExclusive'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinExclusiveConstraintComponent-minExclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.literal(`1`, factory.namedNode('http://www.w3.org/2001/XMLSchema#integer')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinExclusiveConstraintComponent-minExclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#nodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#Literal'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinExclusiveConstraintComponent-minExclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#minExclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinExclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinExclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to restrict the range of value nodes with a minimum exclusive value.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinExclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinExclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Min-exclusive constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinExclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#MinExclusiveConstraintComponent-minExclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinInclusiveConstraintComponent-minInclusive'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinInclusiveConstraintComponent-minInclusive'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinInclusiveConstraintComponent-minInclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.literal(`1`, factory.namedNode('http://www.w3.org/2001/XMLSchema#integer')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinInclusiveConstraintComponent-minInclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#nodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#Literal'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinInclusiveConstraintComponent-minInclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#minInclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinInclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinInclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to restrict the range of value nodes with a minimum inclusive value.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinInclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinInclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Min-inclusive constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinInclusiveConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#MinInclusiveConstraintComponent-minInclusive'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinLengthConstraintComponent-minLength'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinLengthConstraintComponent-minLength'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinLengthConstraintComponent-minLength'),
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#integer'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinLengthConstraintComponent-minLength'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.literal(`1`, factory.namedNode('http://www.w3.org/2001/XMLSchema#integer')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinLengthConstraintComponent-minLength'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#minLength'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinLengthConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinLengthConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to restrict the minimum string length of value nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinLengthConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinLengthConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Min-length constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#MinLengthConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#MinLengthConstraintComponent-minLength'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeConstraintComponent-node'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeConstraintComponent-node'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeConstraintComponent-node'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#node'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to verify that all value nodes conform to the given node shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Node constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#NodeConstraintComponent-node'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKind'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKind'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of all node kinds, including sh:BlankNode, sh:IRI, sh:Literal or the combinations of these: sh:BlankNodeOrIRI, sh:BlankNodeOrLiteral, sh:IRIOrLiteral.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKind'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKind'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Node kind`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKind'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKindConstraintComponent-nodeKind'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKindConstraintComponent-nodeKind'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKindConstraintComponent-nodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#in'),
      blankNodes['b0_c14n6'],
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKindConstraintComponent-nodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.literal(`1`, factory.namedNode('http://www.w3.org/2001/XMLSchema#integer')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKindConstraintComponent-nodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#nodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKindConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKindConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to restrict the RDF node kind of each value node.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKindConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKindConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Node-kind constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKindConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKindConstraintComponent-nodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeShape'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A node shape is a shape that specifies constraint that need to be met with respect to focus nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Node shape`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NodeShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NotConstraintComponent-not'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NotConstraintComponent-not'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NotConstraintComponent-not'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#not'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NotConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NotConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to verify that value nodes do not conform to a given shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NotConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NotConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Not constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#NotConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#NotConstraintComponent-not'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#OrConstraintComponent-or'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#OrConstraintComponent-or'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#OrConstraintComponent-or'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#or'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#OrConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#OrConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to restrict the value nodes so that they conform to at least one out of several provided shapes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#OrConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#OrConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Or constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#OrConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#OrConstraintComponent-or'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of parameter declarations, consisting of a path predicate and (possibly) information about allowed value type, cardinality and other characteristics.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Parameter`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyShape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Parameterizable'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Parameterizable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Superclass of components that can take parameters, especially functions and constraint components.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Parameterizable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Parameterizable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Parameterizable`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Parameterizable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent-flags'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent-flags'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent-flags'),
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#string'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent-flags'),
      factory.namedNode('http://www.w3.org/ns/shacl#optional'),
      factory.literal(`true`, factory.namedNode('http://www.w3.org/2001/XMLSchema#boolean')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent-flags'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#flags'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent-pattern'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent-pattern'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent-pattern'),
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#string'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent-pattern'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#pattern'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to verify that every value node matches a given regular expression.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Pattern constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent-flags'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#PatternConstraintComponent-pattern'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PrefixDeclaration'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PrefixDeclaration'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of prefix declarations, consisting of pairs of a prefix with a namespace.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PrefixDeclaration'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PrefixDeclaration'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Prefix declaration`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PrefixDeclaration'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyConstraintComponent-property'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyConstraintComponent-property'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyConstraintComponent-property'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to verify that all value nodes conform to the given property shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Property constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyConstraintComponent-property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyGroup'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyGroup'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Instances of this class represent groups of property shapes that belong together.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyGroup'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyGroup'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Property group`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyGroup'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyShape'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A property shape is a shape that specifies constraints on the values of a focus node for a given property or path.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Property shape`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent-qualifiedMaxCount'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent-qualifiedMaxCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent-qualifiedMaxCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#integer'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent-qualifiedMaxCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedMaxCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent-qualifiedValueShape'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent-qualifiedValueShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent-qualifiedValueShape'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedValueShape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent-qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent-qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent-qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#boolean'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent-qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/ns/shacl#optional'),
      factory.literal(`true`, factory.namedNode('http://www.w3.org/2001/XMLSchema#boolean')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent-qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to verify that a specified maximum number of value nodes conforms to a given shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Qualified-max-count constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent-qualifiedMaxCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent-qualifiedValueShape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMaxCountConstraintComponent-qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent-qualifiedMinCount'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent-qualifiedMinCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent-qualifiedMinCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#integer'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent-qualifiedMinCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedMinCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent-qualifiedValueShape'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent-qualifiedValueShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent-qualifiedValueShape'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedValueShape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent-qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent-qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent-qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#boolean'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent-qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/ns/shacl#optional'),
      factory.literal(`true`, factory.namedNode('http://www.w3.org/2001/XMLSchema#boolean')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent-qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to verify that a specified minimum number of value nodes conforms to a given shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Qualified-min-count constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent-qualifiedMinCount'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent-qualifiedValueShape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#QualifiedMinCountConstraintComponent-qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ResultAnnotation'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ResultAnnotation'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A class of result annotations, which define the rules to derive the values of a given annotation property as extra values for a validation result.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ResultAnnotation'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ResultAnnotation'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Result annotation`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ResultAnnotation'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Rule'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Rule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of SHACL rules. Never instantiated directly.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Rule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Rule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Rule`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Rule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLAskExecutable'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLAskExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of SPARQL executables that are based on an ASK query.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLAskExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLAskExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`SPARQL ASK executable`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLAskExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLAskValidator'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLAskValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of validators based on SPARQL ASK queries. The queries are evaluated for each value node and are supposed to return true if the given node conforms.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLAskValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLAskValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`SPARQL ASK validator`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLAskValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLAskExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLAskValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#Validator'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstraint'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstraint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of constraints based on SPARQL SELECT queries.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstraint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstraint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`SPARQL constraint`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstraint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstraintComponent-sparql'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstraintComponent-sparql'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstraintComponent-sparql'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#sparql'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to define constraints based on SPARQL queries.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`SPARQL constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstraintComponent-sparql'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstructExecutable'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstructExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of SPARQL executables that are based on a CONSTRUCT query.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstructExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstructExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`SPARQL CONSTRUCT executable`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstructExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLExecutable'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of resources that encapsulate a SPARQL query.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`SPARQL executable`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLFunction'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLFunction'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A function backed by a SPARQL query - either ASK or SELECT.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLFunction'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLFunction'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`SPARQL function`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLFunction'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#Function'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLFunction'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLAskExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLFunction'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLRule'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLRule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of SHACL rules based on SPARQL CONSTRUCT queries.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLRule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLRule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`SPARQL CONSTRUCT rule`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLRule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#Rule'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLRule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstructExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectExecutable'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of SPARQL executables based on a SELECT query.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`SPARQL SELECT executable`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectValidator'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of validators based on SPARQL SELECT queries. The queries are evaluated for each focus node and are supposed to produce bindings for all focus nodes that do not conform.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`SPARQL SELECT validator`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#Validator'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLTarget'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLTarget'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of targets that are based on SPARQL queries.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLTarget'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLTarget'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`SPARQL target`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLTarget'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLAskExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLTarget'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLTarget'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#Target'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLTargetType'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLTargetType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The (meta) class for parameterizable targets that are based on SPARQL queries.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLTargetType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLTargetType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`SPARQL target type`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLTargetType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLAskExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLTargetType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLTargetType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#TargetType'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLUpdateExecutable'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLUpdateExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of SPARQL executables based on a SPARQL UPDATE.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLUpdateExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLUpdateExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`SPARQL UPDATE executable`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLUpdateExecutable'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Severity'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Severity'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of validation result severity levels, including violation and warning levels.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Severity'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Severity'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Severity`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Severity'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A shape is a collection of constraints that may be targeted for certain nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Shape`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Target'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Target'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The base class of targets such as those based on SPARQL queries.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Target'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Target'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Target`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Target'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#TargetType'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#TargetType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The (meta) class for parameterizable targets.	Instances of this are instantiated as values of the sh:target property.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#TargetType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#TargetType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Target type`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#TargetType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#TargetType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameterizable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#TripleRule'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#TripleRule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#TripleRule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`A rule based on triple (subject, predicate, object) pattern.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#TripleRule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#Rule'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#UniqueLangConstraintComponent-uniqueLang'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#UniqueLangConstraintComponent-uniqueLang'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#UniqueLangConstraintComponent-uniqueLang'),
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#boolean'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#UniqueLangConstraintComponent-uniqueLang'),
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.literal(`1`, factory.namedNode('http://www.w3.org/2001/XMLSchema#integer')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#UniqueLangConstraintComponent-uniqueLang'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#uniqueLang'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#UniqueLangConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#UniqueLangConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to specify that no pair of value nodes may use the same language tag.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#UniqueLangConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#UniqueLangConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Unique-languages constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#UniqueLangConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#UniqueLangConstraintComponent-uniqueLang'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ValidationReport'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ValidationReport'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of SHACL validation reports.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ValidationReport'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ValidationReport'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Validation report`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ValidationReport'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ValidationResult'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ValidationResult'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of validation results.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ValidationResult'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ValidationResult'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Validation result`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ValidationResult'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/ns/shacl#AbstractResult'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Validator'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Validator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The class of validators, which provide instructions on how to process a constraint definition. This class serves as base class for the SPARQL-based validators and other possible implementations.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Validator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Validator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Validator`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Validator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Violation'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Severity'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Violation'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The severity for a violation validation result.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Violation'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Violation'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Violation`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Warning'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Severity'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Warning'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The severity for a warning validation result.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Warning'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#Warning'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Warning`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#XoneConstraintComponent-xone'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#XoneConstraintComponent-xone'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#XoneConstraintComponent-xone'),
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/ns/shacl#xone'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#XoneConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#XoneConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A constraint component that can be used to restrict the value nodes so that they conform to exactly one out of several provided shapes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#XoneConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#XoneConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`Exactly one constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#XoneConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#XoneConstraintComponent-xone'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#alternativePath'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#alternativePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The (single) value of this property must be a list of path elements, representing the elements of alternative paths.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#alternativePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#alternativePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`alternative path`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#alternativePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#List'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#and'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#and'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`RDF list of shapes to validate the value nodes against.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#and'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#and'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`and`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#and'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#List'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationProperty'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationProperty'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The annotation property that shall be set.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationProperty'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#ResultAnnotation'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationProperty'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationProperty'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`annotation property`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationProperty'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationValue'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationValue'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The (default) values of the annotation property.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationValue'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#ResultAnnotation'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationValue'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationValue'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`annotation value`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationVarName'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationVarName'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The name of the SPARQL variable from the SELECT clause that shall be used for the values.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationVarName'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#ResultAnnotation'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationVarName'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationVarName'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`annotation variable name`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#annotationVarName'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#string'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ask'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ask'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The SPARQL ASK query to execute.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ask'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLAskExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ask'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ask'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`ask`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ask'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#string'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#class'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#class'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The type that all value nodes must have.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#class'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#class'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`class`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#class'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#closed'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#closed'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`If set to true then the shape is closed.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#closed'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#closed'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`closed`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#closed'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#boolean'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#condition'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#condition'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The shapes that the focus nodes need to conform to before a rule is executed on them.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#condition'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#Rule'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#condition'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#condition'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`condition`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#condition'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#conforms'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#conforms'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`True if the validation did not produce any validation results, and false otherwise.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#conforms'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#ValidationReport'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#conforms'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#conforms'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`conforms`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#conforms'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#boolean'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#construct'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#construct'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The SPARQL CONSTRUCT query to execute.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#construct'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstructExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#construct'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#construct'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`construct`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#construct'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#string'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies an RDF datatype that all value nodes must have.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`datatype`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#datatype'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Datatype'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#deactivated'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#deactivated'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`If set to true then all nodes conform to this.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#deactivated'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#deactivated'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`deactivated`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#deactivated'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#boolean'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#declare'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#declare'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Links a resource with its namespace prefix declarations.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#declare'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/2002/07/owl#Ontology'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#declare'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#declare'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`declare`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#declare'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#PrefixDeclaration'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#defaultValue'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#defaultValue'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A default value for a property, for example for user interface tools to pre-populate input fields.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#defaultValue'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyShape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#defaultValue'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#defaultValue'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`default value`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#description'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#description'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Human-readable descriptions for the property in the context of the surrounding shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#description'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyShape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#description'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#description'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`description`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#detail'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#detail'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Links a result with other results that provide more details, for example to describe violations against nested shapes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#detail'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#AbstractResult'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#detail'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#detail'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`detail`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#detail'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#AbstractResult'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#disjoint'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#disjoint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies a property where the set of values must be disjoint with the value nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#disjoint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#disjoint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`disjoint`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#disjoint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#entailment'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#entailment'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`An entailment regime that indicates what kind of inferencing is required by a shapes graph.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#entailment'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/2002/07/owl#Ontology'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#entailment'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#entailment'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`entailment`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#entailment'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#equals'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#equals'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies a property that must have the same values as the value nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#equals'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#equals'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`equals`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#equals'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#expression'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#expression'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The node expression that must return true for the value nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#expression'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#expression'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`expression`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#filterShape'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#filterShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The shape that all input nodes of the expression need to conform to.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#filterShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#filterShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`filter shape`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#filterShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#flags'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#flags'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`An optional flag to be used with regular expression pattern matching.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#flags'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#flags'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`flags`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#flags'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#string'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#focusNode'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#focusNode'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The focus node that was validated when the result was produced.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#focusNode'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#AbstractResult'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#focusNode'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#focusNode'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`focus node`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#group'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#group'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Can be used to link to a property group to indicate that a property shape belongs to a group of related property shapes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#group'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyShape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#group'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#group'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`group`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#group'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyGroup'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#hasValue'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#hasValue'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies a value that must be among the value nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#hasValue'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#hasValue'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`has value`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ignoredProperties'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ignoredProperties'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`An optional RDF list of properties that are also permitted in addition to those explicitly enumerated via sh:property/sh:path.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ignoredProperties'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ignoredProperties'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`ignored properties`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#ignoredProperties'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#List'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#in'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#in'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies a list of allowed values so that each value node must be among the members of the given list.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#in'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#in'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`in`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#in'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#List'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#intersection'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#intersection'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A list of node expressions that shall be intersected.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#intersection'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#intersection'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`intersection`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#inversePath'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#inversePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The (single) value of this property represents an inverse path (object to subject).`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#inversePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#inversePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`inverse path`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#inversePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#js'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#js'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Constraints expressed in JavaScript.`, factory.namedNode('http://www.w3.org/2001/XMLSchema#string')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#js'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#js'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`JavaScript constraint`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#js'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#JSConstraint'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsFunctionName'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsFunctionName'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The name of the JavaScript function to execute.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsFunctionName'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#JSExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsFunctionName'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsFunctionName'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`JavaScript function name`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsFunctionName'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#string'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsLibrary'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsLibrary'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Declares which JavaScript libraries are needed to execute this.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsLibrary'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsLibrary'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`JavaScript library`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsLibrary'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#JSLibrary'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsLibraryURL'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsLibraryURL'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Declares the URLs of a JavaScript library. This should be the absolute URL of a JavaScript file. Implementations may redirect those to local files.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsLibraryURL'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#JSLibrary'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsLibraryURL'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsLibraryURL'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`JavaScript library URL`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#jsLibraryURL'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#anyURI'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#labelTemplate'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#labelTemplate'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Outlines how human-readable labels of instances of the associated Parameterizable shall be produced. The values can contain {?paramName} as placeholders for the actual values of the given parameter.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#labelTemplate'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameterizable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#labelTemplate'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#labelTemplate'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`label template`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#languageIn'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#languageIn'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies a list of language tags that all value nodes must have.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#languageIn'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#languageIn'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`language in`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#languageIn'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#List'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#lessThan'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#lessThan'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies a property that must have smaller values than the value nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#lessThan'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#lessThan'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`less than`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#lessThan'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#lessThanOrEquals'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#lessThanOrEquals'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies a property that must have smaller or equal values than the value nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#lessThanOrEquals'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#lessThanOrEquals'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`less than or equals`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#lessThanOrEquals'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies the maximum number of values in the set of value nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`max count`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#integer'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxExclusive'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxExclusive'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies the maximum exclusive value of each value node.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxExclusive'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxExclusive'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`max exclusive`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxInclusive'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxInclusive'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies the maximum inclusive value of each value node.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxInclusive'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxInclusive'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`max inclusive`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxLength'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxLength'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies the maximum string length of each value node.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxLength'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxLength'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`max length`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#maxLength'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#integer'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#message'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#message'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A human-readable message (possibly with placeholders for variables) explaining the cause of the result.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#message'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#message'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`message`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minCount'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies the minimum number of values in the set of value nodes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`min count`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#integer'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minExclusive'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minExclusive'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies the minimum exclusive value of each value node.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minExclusive'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minExclusive'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`min exclusive`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minInclusive'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minInclusive'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies the minimum inclusive value of each value node.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minInclusive'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minInclusive'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`min inclusive`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minLength'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minLength'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies the minimum string length of each value node.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minLength'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minLength'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`min length`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#minLength'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#integer'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#name'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#name'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Human-readable labels for the property in the context of the surrounding shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#name'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyShape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#name'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#name'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`name`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#namespace'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#namespace'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The namespace associated with a prefix in a prefix declaration.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#namespace'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#PrefixDeclaration'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#namespace'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#namespace'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`namespace`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#namespace'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#anyURI'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#node'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#node'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies the node shape that all value nodes must conform to.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#node'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#node'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`node`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#node'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#NodeShape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#nodeKind'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#nodeKind'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies the node kind (e.g. IRI or literal) each value node.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#nodeKind'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#nodeKind'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`node kind`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#nodeKind'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#NodeKind'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#nodeValidator'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#nodeValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The validator(s) used to evaluate a constraint in the context of a node shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#nodeValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#nodeValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#nodeValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`shape validator`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#nodeValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#Validator'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#nodes'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#nodes'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The node expression producing the input nodes of a filter shape expression.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#nodes'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#nodes'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`nodes`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#not'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#not'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies a shape that the value nodes must not conform to.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#not'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#not'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`not`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#not'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#object'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#object'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`An expression producing the nodes that shall be inferred as objects.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#object'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#TripleRule'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#object'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#object'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`object`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#oneOrMorePath'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#oneOrMorePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The (single) value of this property represents a path that is matched one or more times.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#oneOrMorePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#oneOrMorePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`one or more path`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#oneOrMorePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#optional'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#optional'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Indicates whether a parameter is optional.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#optional'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#optional'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#optional'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`optional`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#optional'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#boolean'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#or'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#or'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies a list of shapes so that the value nodes must conform to at least one of the shapes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#or'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#or'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`or`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#or'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#List'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#order'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#order'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies the relative order of this compared to its siblings. For example use 0 for the first, 1 for the second.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#order'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#order'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`order`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The parameters of a function or constraint component.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameterizable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`parameter`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#parameter'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#Parameter'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies the property path of a property shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyShape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`path`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#path'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#pattern'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#pattern'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies a regular expression pattern that the string representations of the value nodes must match.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#pattern'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#pattern'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`pattern`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#pattern'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#string'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#predicate'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#predicate'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`An expression producing the properties that shall be inferred as predicates.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#predicate'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#TripleRule'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#predicate'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#predicate'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`predicate`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#prefix'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#prefix'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The prefix of a prefix declaration.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#prefix'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#PrefixDeclaration'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#prefix'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#prefix'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`prefix`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#prefix'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#string'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#prefixes'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#prefixes'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The prefixes that shall be applied before parsing the associated SPARQL query.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#prefixes'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#prefixes'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#prefixes'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`prefixes`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#prefixes'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2002/07/owl#Ontology'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#property'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#property'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Links a shape to its property shapes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#property'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#property'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#property'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`property`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#property'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#PropertyShape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#propertyValidator'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#propertyValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The validator(s) used to evaluate a constraint in the context of a property shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#propertyValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#propertyValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#propertyValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`property validator`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#propertyValidator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#Validator'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedMaxCount'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedMaxCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The maximum number of value nodes that can conform to the shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedMaxCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedMaxCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`qualified max count`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedMaxCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#integer'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedMinCount'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedMinCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The minimum number of value nodes that must conform to the shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedMinCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedMinCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`qualified min count`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedMinCount'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#integer'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedValueShape'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedValueShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The shape that a specified number of values must conform to.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedValueShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedValueShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`qualified value shape`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedValueShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Can be used to mark the qualified value shape to be disjoint with its sibling shapes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`qualified value shapes disjoint`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#qualifiedValueShapesDisjoint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#boolean'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#result'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#result'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The validation results contained in a validation report.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#result'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#ValidationReport'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#result'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#result'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`result`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#result'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#ValidationResult'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultAnnotation'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultAnnotation'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Links a SPARQL validator with zero or more sh:ResultAnnotation instances, defining how to derive additional result properties based on the variables of the SELECT query.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultAnnotation'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectValidator'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultAnnotation'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultAnnotation'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`result annotation`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultAnnotation'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#ResultAnnotation'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultMessage'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultMessage'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Human-readable messages explaining the cause of the result.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultMessage'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#AbstractResult'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultMessage'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultMessage'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`result message`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultPath'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultPath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The path of a validation result, based on the path of the validated property shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultPath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#AbstractResult'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultPath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultPath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`result path`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultPath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultSeverity'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultSeverity'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The severity of the result, e.g. warning.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultSeverity'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#AbstractResult'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultSeverity'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultSeverity'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`result severity`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#resultSeverity'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#Severity'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#returnType'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#returnType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The expected type of values returned by the associated function.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#returnType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#Function'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#returnType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#returnType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`return type`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#returnType'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#rule'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#rule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The rules linked to a shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#rule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#rule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#rule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`rule`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#rule'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#Rule'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#select'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#select'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The SPARQL SELECT query to execute.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#select'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLSelectExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#select'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#select'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`select`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#select'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#string'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#severity'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#severity'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Defines the severity that validation results produced by a shape must have. Defaults to sh:Violation.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#severity'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#severity'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#severity'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`severity`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#severity'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#Severity'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#shapesGraph'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#shapesGraph'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Shapes graphs that should be used when validating this data graph.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#shapesGraph'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/2002/07/owl#Ontology'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#shapesGraph'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#shapesGraph'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`shapes graph`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#shapesGraph'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2002/07/owl#Ontology'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#shapesGraphWellFormed'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#shapesGraphWellFormed'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`If true then the validation engine was certain that the shapes graph has passed all SHACL syntax requirements during the validation process.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#shapesGraphWellFormed'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#ValidationReport'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#shapesGraphWellFormed'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#shapesGraphWellFormed'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`shapes graph well-formed`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#shapesGraphWellFormed'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#boolean'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceConstraint'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceConstraint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The constraint that was validated when the result was produced.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceConstraint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#AbstractResult'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceConstraint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceConstraint'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`source constraint`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceConstraintComponent'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The constraint component that is the source of the result.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#AbstractResult'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`source constraint component`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceConstraintComponent'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceShape'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The shape that is was validated when the result was produced.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#AbstractResult'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`source shape`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sourceShape'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sparql'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sparql'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Links a shape with SPARQL constraints.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sparql'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sparql'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sparql'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`constraint (in SPARQL)`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#sparql'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLConstraint'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#subject'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#subject'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`An expression producing the resources that shall be inferred as subjects.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#subject'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#TripleRule'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#subject'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#subject'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`subject`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#suggestedShapesGraph'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#suggestedShapesGraph'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Suggested shapes graphs for this ontology. The values of this property may be used in the absence of specific sh:shapesGraph statements.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#suggestedShapesGraph'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/2002/07/owl#Ontology'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#suggestedShapesGraph'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#suggestedShapesGraph'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`suggested shapes graph`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#suggestedShapesGraph'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2002/07/owl#Ontology'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#target'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#target'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Links a shape to a target specified by an extension language, for example instances of sh:SPARQLTarget.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#target'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#target'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#target'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`target`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#target'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#Target'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetClass'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetClass'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Links a shape to a class, indicating that all instances of the class must conform to the shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetClass'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetClass'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetClass'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`target class`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetClass'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Class'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetNode'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetNode'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Links a shape to individual nodes, indicating that these nodes must conform to the shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetNode'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetNode'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetNode'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`target node`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetObjectsOf'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetObjectsOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Links a shape to a property, indicating that all all objects of triples that have the given property as their predicate must conform to the shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetObjectsOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetObjectsOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetObjectsOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`target objects of`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetObjectsOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetSubjectsOf'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetSubjectsOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Links a shape to a property, indicating that all subjects of triples that have the given property as their predicate must conform to the shape.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetSubjectsOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#Shape'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetSubjectsOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetSubjectsOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`target subjects of`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#targetSubjectsOf'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#this'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#this'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A node expression that represents the current focus node.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#this'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#this'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`this`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#union'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#union'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`A list of node expressions that shall be used together.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#union'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#union'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`union`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#uniqueLang'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#uniqueLang'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies whether all node values must have a unique (or no) language tag.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#uniqueLang'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#uniqueLang'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`unique languages`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#uniqueLang'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#boolean'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#update'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#update'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The SPARQL UPDATE to execute.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#update'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#SPARQLUpdateExecutable'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#update'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#update'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`update`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#update'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2001/XMLSchema#string'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#validator'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#validator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The validator(s) used to evaluate constraints of either node or property shapes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#validator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#ConstraintComponent'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#validator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#validator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`validator`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#validator'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/ns/shacl#Validator'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#value'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#value'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`An RDF node that has caused the result.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#value'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'),
      factory.namedNode('http://www.w3.org/ns/shacl#AbstractResult'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#value'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#value'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`value`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#xone'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#xone'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`Specifies a list of shapes so that the value nodes must conform to exactly one of the shapes.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#xone'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#xone'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`exactly one`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#xone'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#List'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#zeroOrMorePath'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#zeroOrMorePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The (single) value of this property represents a path that is matched zero or more times.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#zeroOrMorePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#zeroOrMorePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`zero or more path`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#zeroOrMorePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#zeroOrOnePath'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#Property'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#zeroOrOnePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#comment'),
      factory.literal(`The (single) value of this property represents a path that is matched zero or one times.`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#zeroOrOnePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#isDefinedBy'),
      factory.namedNode('http://www.w3.org/ns/shacl#'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#zeroOrOnePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#label'),
      factory.literal(`zero or one path`, 'en'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      factory.namedNode('http://www.w3.org/ns/shacl#zeroOrOnePath'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'),
      factory.namedNode('http://www.w3.org/2000/01/rdf-schema#Resource'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      blankNodes['b0_c14n0'],
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#first'),
      factory.namedNode('http://www.w3.org/ns/shacl#BlankNodeOrIRI'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      blankNodes['b0_c14n0'],
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#rest'),
      blankNodes['b0_c14n1'],
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      blankNodes['b0_c14n1'],
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#first'),
      factory.namedNode('http://www.w3.org/ns/shacl#BlankNodeOrLiteral'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      blankNodes['b0_c14n1'],
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#rest'),
      blankNodes['b0_c14n5'],
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      blankNodes['b0_c14n2'],
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#first'),
      factory.namedNode('http://www.w3.org/ns/shacl#Literal'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      blankNodes['b0_c14n2'],
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#rest'),
      blankNodes['b0_c14n0'],
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      blankNodes['b0_c14n3'],
      factory.namedNode('http://www.w3.org/ns/shacl#namespace'),
      factory.literal(`http://www.w3.org/ns/shacl#`, factory.namedNode('http://www.w3.org/2001/XMLSchema#string')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      blankNodes['b0_c14n3'],
      factory.namedNode('http://www.w3.org/ns/shacl#prefix'),
      factory.literal(`sh`, factory.namedNode('http://www.w3.org/2001/XMLSchema#string')),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      blankNodes['b0_c14n4'],
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#first'),
      factory.namedNode('http://www.w3.org/ns/shacl#IRI'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      blankNodes['b0_c14n4'],
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#rest'),
      blankNodes['b0_c14n2'],
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      blankNodes['b0_c14n5'],
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#first'),
      factory.namedNode('http://www.w3.org/ns/shacl#IRIOrLiteral'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      blankNodes['b0_c14n5'],
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#rest'),
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#nil'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      blankNodes['b0_c14n6'],
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#first'),
      factory.namedNode('http://www.w3.org/ns/shacl#BlankNode'),
      factory.namedNode('http://www.w3.org/ns/shacl#')
    ),
    factory.quad(
      blankNodes['b0_c14n6'],
      factory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#rest'),
      blankNodes['b0_c14n4'],
      factory.namedNode('http://www.w3.org/ns/shacl#')
    )
  ]
}
